export default {
  title: {
    id: 'header_bo_logo_title',
    defaultMessage: 'Go to Dashboard',
  },
  hello: {
    id: 'header_bo_merchant_hello_company',
    defaultMessage: 'Hello {company}',
  },
  boTypeSales: {
    id: 'header_bo_sell',
    defaultMessage: 'Sales',
  },
  boTypeTradeIn: {
    id: 'header_bo_buyback',
    defaultMessage: 'Buyback',
  },
  selectBoType: {
    id: 'header_bo_select_bo_type',
    defaultMessage: 'TYPE',
  },
  selectLanguage: {
    id: 'header_bo_select_language',
    defaultMessage: 'LG',
  },
}
